export default {"id":"6c7800e8","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}